import { useNavigate, useSearchParams } from 'react-router-dom'
import { ETenderStatus, ETenderType } from 'types/tender'
import PageWrapper from 'hoc/PageWrapper'
import { Box, Button, Typography, Divider, Grid, TextField } from '@mui/material'
import { tenderTypeToTitle } from 'utils/tender'
import { useEffect, useState } from 'react'
import { useCreateTenderMutation } from 'services/tender'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

export function CreateTender() {
  const [name, setName] = useState('')
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const type = params.get('type') as ETenderType
  const [createTender, { data, isLoading: isCreateLoading }] =
    useCreateTenderMutation()
  const { t } = useTranslation()

  const handleCreateClick = async () => {
    const data = await createTender({
      name,
      active: true,
      method: type,
      status: ETenderStatus.CREATED,
    })

    if ('error' in data && 'status' in data.error) {
      if (data.error.status === 400) {
        toast.warning(t('duplicateTenderError'))
      }
    }
  }

  useEffect(() => {
    if (data?.id) {
      navigate(`/portal/tenders/${data.id}/edit?type=${type}`)
    }
  }, [data?.id, navigate])

  if (!type) {
    navigate('/')
  }

  return (
    <PageWrapper>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography fontWeight={700}>{t('procurementMethod')}</Typography>
        <Button
          size="small"
          variant="outlined"
          onClick={() => navigate(`/portal/tenders?type=${type}`)}
        >
          {t('back')}
        </Button>
      </Box>
      <Divider sx={{ my: 1.5 }} />
      <Grid spacing={2} container>
        <Grid item xs={4}>
          <Box
            display="flex"
            width="100%"
            height="100%"
            justifyContent="center"
            alignItems="center"
          >
            <Typography textAlign="center">{t(tenderTypeToTitle(type))}</Typography>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            size="small"
            placeholder={t('contestName')}
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={4}>
          <Button
            fullWidth
            disabled={!name || isCreateLoading}
            onClick={handleCreateClick}
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
          >
            {t('createNew')}
          </Button>
        </Grid>
      </Grid>
    </PageWrapper>
  )
}
